/** @jsxImportSource @emotion/react */

import { vars } from "@imwebme/clay-token";
import type { PropsWithChildren } from "react";
import { useLayoutEffect, useRef } from "react";
import type { ModalProps } from "..";
import { Flex } from "..";
import { overlayAnimation } from "./Modal.css";

export const ModalOverlay = ({
  children,
  closeOnBackdrop,
  setClose,
}: PropsWithChildren<Pick<ModalProps, "closeOnBackdrop" | "setClose">>) => {
  const ref = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    if (ref.current) ref.current.focus();
  }, []);

  return (
    <Flex.Center
      ref={ref}
      position="fixed"
      top={0}
      left={0}
      right={0}
      bottom={0}
      zIndex="var(--clay-zIndex-modal)"
      padding="32px"
      background={vars.semantic.color.backdrop}
      animation={`${overlayAnimation} 0.1s ease-out`}
      native={{
        tabIndex: -1,
        onClick: () => {
          if (closeOnBackdrop) {
            setClose();
          }
        },
      }}
    >
      {children}
    </Flex.Center>
  );
};

ModalOverlay.displayName = "ModalOverlay";
